const s = (n, e, o = !n.has(e)) => {
  const t = new Set(n);
  return o ? t.add(e) : t.delete(e), t;
};
export {
  s as toggleSelection
};
